<template>
  <div class="flex items-center">
    <vx-tooltip position="top"
                :text="tooltipText"
                class="flex items-center"
                :enabled="true"
    >
      <span class="text-gray-dark">
        {{ resolveLastUpdateFromNow }}
      </span>
    </vx-tooltip>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'IndexExecutionLastUpdate',

  props: {
    indexExecution: {
      type: Object,
      required: true
    }
  },

  computed: {
    timestamp() {
      const timestamp = this.indexExecution.finished_on || this.indexExecution.created_on
      return moment(timestamp)
    },
    resolveLastUpdateFromNow() {
      return this.timestamp.fromNow()
    },
    indexExecutionDuration() {
      if (!this.indexExecution.finished_on) return null

      const duration = moment.duration(moment(this.indexExecution.finished_on).diff(moment(this.indexExecution.created_on)))
      return duration.humanize()
    },
    tooltipText() {
      const text = `<strong>Last update:</strong><br/>${this.timestamp.format('LL HH:mm:ss')}`
      if (this.indexExecutionDuration) {
        return `${text}<br/><br/><strong>Duration:</strong><br/>${this.indexExecutionDuration}`
      }

      return text
    }
  }
}
</script>
